import { AssessmentField, UserAssessmentResultValue } from './_types';

/**
 * Initialize assessment results with default values for toggle and default options.
 * Matches v3's initializeResults() behavior.
 */
export function initializeAssessmentResults(
  fields: AssessmentField[],
  scored?: boolean
): UserAssessmentResultValue[] {
  return fields.map((f) => {
    const r: UserAssessmentResultValue = { type: f.type, label: f.label };

    // Initialize toggle with first option
    if (f.type === 'toggle' && f.options?.[0]) {
      r.value = f.options[0].label;
      if (scored) r.points = f.options[0].points;
    }
    // Initialize fields with default option
    else if (f.options) {
      const def = f.options.find((o) => o.default);
      if (def) {
        r.value = def.label;
        if (scored) r.points = def.points;
      }
    }

    return r;
  });
}
